import React, { useState, useEffect } from "react";
import { AxiosError } from "axios";
import Images from "../../../static";
import { getCurrentChild } from "src/shared/redux-state/src";
import { useAppSelector } from "src/app/services/store";
import { AccountSummaryType } from "src/shared/types/src/lib/invoice.types";
import { ChildrenStoreData } from "src/shared/types/src";
import { getAccountSummary } from "src/shared/services/src/lib/invoice";
import { getFormattedAmount } from "src/shared/utils/src";
import BaseCard from "src/app/components/commonComponents/BaseCard";
import CustomButton from "src/app/components/commonComponents/CustomButton";
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from "src/app/navigation/routes";
import { AccountSummaryLoader } from "src/app/components";
import CustomAmountComponent from "src/app/components/CustomAmountComponent";

const AccountCard = () => {
	const navigate = useNavigate()

	const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

	const [loading, setLoading] = useState<boolean>(false);
	const [summary, setSummary] = useState<AccountSummaryType>();
	const [isBillPayer, setBillPayer] = useState<boolean>(false);

	useEffect(() => {
		init(currentChild);
	}, [currentChild.childInstanceKey]);

	const init = async (currentChildLocal: ChildrenStoreData) => {
		try {
			setLoading(true);

			const response = await getAccountSummary({ child: currentChildLocal });
			console.log("response from account summary api : ", response);
			if (response && Object.keys(response).length) {
				setSummary(response);
				setBillPayer(true);
			} else {
				setSummary(undefined);
				setBillPayer(false);
			}
		} catch (error) {
			console.log("SUMMARY : ", summary);
			setSummary(undefined);
			if (error instanceof AxiosError) {
				const apiError = error as AxiosError;
				if (apiError && apiError.response && apiError.response.status === 403) {
					setBillPayer(false);
				}
			}
		} finally {
			setLoading(false);
		}
	};

	const handleClick = () => {
		navigate(AppRoutes.INVOICE);
	}

	return (
		<BaseCard>
			<div className="section-with-img">
				<div className="section-img">
					<img src={Images.accountSummary} alt="account-summary" />
				</div>
				<span className="fs-12 fw-semibold text-black flex-1 pd-l-10">Account Summary</span>
			</div>

			<div className="row">
				<div className="col-6 mg-t-20 text-center border-end">
						{loading ? (
							<AccountSummaryLoader />
						) : (
							<h2 className="mg-b-0 fw-light">
								{summary?.balance && isBillPayer
									? <CustomAmountComponent amount={summary?.balance} currency={summary?.currency} applyColor={true} applyFormat={true} />
									: "£0.00"}
							</h2>
						)}
						<p className="mg-b-0 fs-12 text-black mg-t-10 fw-bold">Balance</p>
				</div>
				<div className="col-6 mg-t-20 text-center">
					{loading ? (
						<AccountSummaryLoader />
					) : (
						<h2 className="mg-b-0 fw-light">
							{summary?.depositAmount && isBillPayer
									? <CustomAmountComponent amount={summary?.depositAmount} currency={summary?.currency} applyFormat={true} withSign={false} />
								: "£0.00"}
						</h2>
					)}
					<p className="mg-b-0 fs-12 text-black mg-t-10 fw-bold">Deposit</p>
				</div>
			</div>

			{!loading &&
				isBillPayer &&
				summary?.balance &&
				!summary?.balance.startsWith("-") &&
				parseInt(summary?.balance) !== 0 ? (
				<p className="mb-0 text-black fs-12 mg-t-20 text-center">Your account is in debit</p>
			) : null}
			{!loading && !isBillPayer ? (
				<p className="mb-0 text-black fs-12 mg-t-20 text-center">You have not been added as a bill payer</p>
			) : null}
			<CustomButton text="View Details" onClick={handleClick} color={"primary"} customBtnStyle="mg-t-20" />
		</BaseCard>
	);
};

export default AccountCard;
